'use strict';

(function($) {
    $(function() {
        $(document).ready(function() {
            if ('function' == typeof window.IntersectionObserver) {
                // lazyload images
                // for images: <img class="lazy" data-src="">
                var lazyImageObserver = new IntersectionObserver(
                    function(entries) {
                        entries.forEach(function(lazyImage) {
                            if (lazyImage.intersectionRatio <= 0) {
                                return;
                            }
                            lazyImage.target.src = lazyImage.target.dataset.src;
                            if (lazyImage.target.dataset.srcset) {
                                lazyImage.target.srcset = lazyImage.target.dataset.srcset;
                            }
                            lazyImage.target.classList.remove('lazy');
                            lazyImageObserver.unobserve(lazyImage.target);
                        });
                    }
                );

                var lazyImages = [].slice.call(document.querySelectorAll('img.lazy'));
                lazyImages.forEach(function(lazyImage) {
                    lazyImageObserver.observe(lazyImage);
                });

                // lazyload iframes
                // for any iframes: <iframe class="lazy" data-src="">
                var lazyIframeObserver = new IntersectionObserver(
                    function(entries) {
                        entries.forEach(function(lazyImage) {
                            if (lazyImage.intersectionRatio <= 0) {
                                return;
                            }
                            lazyImage.target.src = lazyImage.target.dataset.src;
                            lazyImage.target.classList.remove('lazy');
                            lazyIframeObserver.unobserve(lazyImage.target);
                        });
                    }
                );

                var lazyIframes = [].slice.call(document.querySelectorAll('iframe.lazy'));
                lazyIframes.forEach(function(lazyIframe) {
                    lazyIframeObserver.observe(lazyIframe);
                });

                // lazyload backgrounds
                // for any element: <div class="lazybackground" data-backgroundsrc="">
                var lazyBackgroundImageObserver = new IntersectionObserver(
                    function(entries) {
                        entries.forEach(function(lazyImage) {
                            if (lazyImage.intersectionRatio <= 0) {
                                return;
                            }
                            lazyImage.target.style.backgroundImage = "url('"+lazyImage.target.dataset.backgroundsrc+"')";
                            lazyImage.target.classList.remove('lazybackground');
                            lazyBackgroundImageObserver.unobserve(lazyImage.target);
                        });
                    }
                );

                var lazyBackgroundImages = [].slice.call(document.querySelectorAll('.lazybackground'));
                lazyBackgroundImages.forEach(function(lazyBackgroundImage) {
                    lazyBackgroundImageObserver.observe(lazyBackgroundImage);
                });

                // lazyload video
                // for videos: <source data-src="one-does-not-simply.webm" type="video/webm">
                var lazyVideos = [].slice.call(document.querySelectorAll('video.lazy'));
                var lazyVideoObserver = new IntersectionObserver(function(entries, observer) {
                    entries.forEach(function(video) {
                        if (video.isIntersecting) {
                            // delay video with 300ms
                            setTimeout(function() {
                                for (var source in video.target.children) {
                                    var videoSource = video.target.children[source];
                                    if (typeof videoSource.tagName === 'string' && videoSource.tagName === 'SOURCE') {
                                        videoSource.src = videoSource.dataset.src;
                                    }
                                }

                                video.target.load();
                                video.target.classList.remove('lazy');
                            }, 300);
                            lazyVideoObserver.unobserve(video.target);
                        }
                    });
                });

                lazyVideos.forEach(function(lazyVideo) {
                    lazyVideoObserver.observe(lazyVideo);
                });

                var lazySlickSlidersObserver = new IntersectionObserver(
                    function(entries) {
                        entries.forEach(function(lazySlickSlider) {
                            if (lazySlickSlider.intersectionRatio <= 0) {
                                return;
                            }

                            var images = lazySlickSlider.target.getElementsByClassName('lazy');

                            for (var i = 0; i < images.length; i++) {
                                images[i].src = images[i].dataset.src;
                                if (images[i].dataset.srcset) {
                                    images[i].srcset = images[i].dataset.srcset;
                                    images[i].classList.remove('lazy');
                                }
                            }

                            lazySlickSlidersObserver.unobserve(lazySlickSlider.target);
                        });
                    }
                );

                var slickSlider = [].slice.call(document.querySelectorAll('.slick-slider'));
                slickSlider.forEach(function(slickSlider) {
                    lazySlickSlidersObserver.observe(slickSlider);
                });
            }

            // no window.IntersectionObserver, sad panda
            if ('function' !== typeof window.IntersectionObserver) {
                // fix images
                var lazyImages = [].slice.call(document.querySelectorAll('img.lazy'));
                lazyImages.forEach(function(lazyImage) {
                    lazyImage.src = lazyImage.dataset.src;
                    if (lazyImage.dataset.srcset) {
                        lazyImage.srcset = lazyImage.dataset.srcset;
                    }
                    lazyImage.classList.remove('lazy');
                });

                // fix backgrounds
                var lazyBgImages = [].slice.call(document.querySelectorAll('.lazybackground'));
                lazyBgImages.forEach(function(lazyImage) {
                    lazyImage.style.backgroundImage = "url('"+lazyImage.dataset.backgroundsrc+"')";
                    lazyImage.classList.remove('lazybackground');
                });

                // fix videos
                var lazyVideos = [].slice.call(document.querySelectorAll('video.lazy'));
                lazyVideos.forEach(function(video) {
                    for (var source in video.children) {
                        var videoSource = video.children[source];
                        if (typeof videoSource.tagName === 'string' && videoSource.tagName === 'SOURCE') {
                            videoSource.src = videoSource.dataset.src;
                        }
                    }

                    video.load();
                    lazyVideos.classList.remove('lazy');
                });

                // fix iframes
                var lazyIframes = [].slice.call(document.querySelectorAll('iframe.lazy'));
                lazyIframes.forEach(function(lazyIframe) {
                    lazyIframe.src = lazyImage.dataset.src;
                });
            }
        });
    });
})(jQuery);
